import React, {FC, useState} from 'react'
import {useSignUp} from '@clerk/react'
import {useNavigate} from 'react-router-dom'

const Step5: FC = () => {
  const {signUp} = useSignUp()
  const navigate = useNavigate()
  const [code, setCode] = useState('')

  const verify = async () => {
    try {
      await signUp.verifications.verifyEmailCode({code})

      if (signUp.status === 'complete') {
        await signUp.finalize({
          navigate: ({decorateUrl}) => {
            const url = decorateUrl('/dashboard')
            navigate(url)
          },
        })
      }
    } catch (err) {
      console.error(err)
    }
  }

  return (
    <div className='w-100'>
      <div className='pb-8 pb-lg-10'>
        <h2 className='fw-bolder text-gray-900'>Verify Your Email</h2>

        <div className='text-gray-500 fw-bold fs-6'>
          We have sent a verification code to your email.
        </div>
      </div>

      <div className='fv-row mb-10'>
        <label className='form-label fw-bold required'>Verification Code</label>

        <input
          type='text'
          className='form-control form-control-lg form-control-solid'
          value={code}
          onChange={(e) => setCode(e.target.value)}
        />
      </div>

      <button className='btn btn-primary' onClick={verify}>
        Verify Email
      </button>
    </div>
  )
}

export {Step5}
